'use client';

import { Button, Icon } from '@/components/ui';
import { cn } from '@/libs';

type ResultsCarouselNavigationProps = {
  onPrev: () => void;
  onNext: () => void;
  canScrollPrev: boolean;
  canScrollNext: boolean;
  'data-cy'?: string;
};

const ARROW_CLASSES = cn(
  'absolute top-1/2 z-10 -translate-y-1/2',
  'flex items-center justify-center w-7 h-7 rounded-full',
  'bg-background/70 backdrop-blur hover:bg-background/90 transition-colors',
);

export const ResultsCarouselNavigation = ({
  onPrev,
  onNext,
  canScrollPrev,
  canScrollNext,
  ...props
}: ResultsCarouselNavigationProps) => {
  const dataCy = props['data-cy'] || 'results-carousel';

  return (
    <>
      {canScrollPrev && (
        <Button
          variant="ghost"
          size="small"
          onClick={onPrev}
          className={cn(ARROW_CLASSES, 'left-2')}
          aria-label="Resultado anterior"
          data-cy={`${dataCy}-prev`}
        >
          <Icon.ChevronLeft width={16} height={16} />
        </Button>
      )}

      {canScrollNext && (
        <Button
          variant="ghost"
          size="small"
          onClick={onNext}
          className={cn(ARROW_CLASSES, 'right-2')}
          aria-label="Próximo resultado"
          data-cy={`${dataCy}-next`}
        >
          <Icon.ChevronRight width={16} height={16} />
        </Button>
      )}
    </>
  );
};
